import clsx from 'clsx';
import _ from 'lodash';

import { Checkbox } from '@/core/Checkbox.atom';

export type RadioButtonOption = {
  id: string;
  label: string | React.ReactNode;
  checked: boolean;
  onToggle: () => void;
  tooltip?: string;
  isTooltipSimple?: boolean;
  description?: string;
  disabled?: boolean;
};

type RadioButtonGroupProps = {
  options: RadioButtonOption[];
  gridLayout?: boolean;
  verticalLayout?: boolean;
  extraClassNames?: string;
  checkboxExtraClassNames?: string;
  onChange?: (option?: RadioButtonOption) => void;
  testId?: string;
};

/** Manage and display a group of radio buttons in a grid, vertical or horizontal (default) layout */
export const RadioButtonGroup = ({
  options,
  gridLayout = false,
  verticalLayout,
  extraClassNames,
  checkboxExtraClassNames,
  onChange,
  testId,
}: RadioButtonGroupProps) => {
  return (
    <div
      data-testid={testId}
      className={clsx(extraClassNames, {
        flexWrap: gridLayout,
        flexAlignCenter: !verticalLayout,
        flexColumnContainer: !verticalLayout,
        flexRowContainer: verticalLayout,
      })}>
      {_.map(options, (option) => (
        <Checkbox
          key={`${option.id}_checkbox`}
          classes={clsx('mr15', { 'width-100': gridLayout, 'mb0': verticalLayout }, checkboxExtraClassNames)}
          type="radio"
          id={option.id}
          label={option.label}
          isChecked={option.checked}
          disabled={option.disabled}
          tooltip={option.tooltip}
          isTooltipSimple={option.isTooltipSimple}
          description={option.description}
          value={option.id}
          onChange={() => {
            onChange?.(option);
            option.onToggle();
          }}
        />
      ))}
    </div>
  );
};
